import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { formatCurrency } from 'utils/common';
import { Drawer, H3, Span } from 'components/Ui';
import OrderItem from 'containers/Orders/OrderItem';
import styles from './styles.scss';

const OrderDetailsDrawer = ({ order, address, onClose }) => {
  const {
    orderNumber,
    orderDate,
    orderLineTotalAmount,
    orderTaxTotal,
    orderTotalAmount,
    trackingNumber,
    equipmentDetails: orderItems,
  } = order || {};

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (orderNumber) setOpen(true);
    return () => setOpen(false);
  }, [orderNumber]);

  if (!orderNumber) return null;

  return (
    <Drawer
      headerTitle="Order Details"
      className={styles.drawer}
      open={open}
      onClose={onClose}
    >
      <article>
        <section className={styles.ids}>
          <H3>{moment(orderDate).format('MMMM D, YYYY')}</H3>
          <p>Order #: {orderNumber}</p>
          {trackingNumber && <p>Tracking #: {trackingNumber}</p>}
          <hr />
        </section>
        <section className={styles.shipping}>
          <h3>Shipping Details</h3>
          <p>{address}</p>
          <hr />
        </section>
        <section className={styles.items}>
          <h3>Items</h3>
          <ol>
            {orderItems.map((item) => (
              <li key={item.itemNumber}>
                <OrderItem {...item} />
              </li>
            ))}
          </ol>
        </section>
        <section className={styles.totals}>
          <h3 className={styles.flexBetween}>
            <Span>Cart Subtotal</Span>
            <Span>{formatCurrency(orderLineTotalAmount)}</Span>
          </h3>
          <div>
            <span className={styles.plusIcon}>+</span>
            <ol>
              <li>
                <Span>Taxes</Span>
                <span>{formatCurrency(orderTaxTotal)}</span>
              </li>
            </ol>
          </div>
          <h4
            className={styles.flexBetween}
            role="status"
            aria-atomic="true"
            aria-live="polite"
          >
            <Span>Order Total</Span>
            <Span>{formatCurrency(orderTotalAmount)}</Span>
          </h4>
        </section>
      </article>
    </Drawer>
  );
};

export default OrderDetailsDrawer;
